<template>
    <sub-page :fullPage="true">
    <div class="menuPage">

        <div class="page-table">
            <div class="map-info">
                <div style="flex:1">
                    <p>学员名字：{{subData.name}}</p>
                    <p>科室：{{subData.orgName}}</p>
                </div>
                <div class="page-operate" style="padding-right: 10px">
                <a :href="exportUrl" ref="exportUser" id="export-b"></a>
                <el-button-group>
                    <el-tooltip class="item" effect="dark" content="导出考勤统计表" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="exportUser('ruleCard')">
                            <label class="btn">
                                <i class="nucfont inuc-daochu"></i>
                            </label>
                        </el-button>
                    </el-tooltip>
                </el-button-group>
            </div>
            </div>

            <data-tables class="form-table"
                         ref="form-table"
                         :data="tableData"
                         :table-props="tableProps"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         :current-page.sync="currentPage"
            >
                <el-table-column :prop="'plan'" :label="'排班日期区间'" :key="'排班日期区间'"
                                 align="center"
                                 sortable="custom">
                    <template slot-scope="props">
                        <div class="expand-box">
                            <p class="expand-table">{{props.row.planStart.substring(0, 10)+'-'+props.row.planEnd.substring(0, 10)}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :prop="'workClock'" :label="'上班时间段'" :key="'上班时间段'"
                                 align="center"
                                 sortable="custom">
                    <template slot-scope="props">
                        <div class="expand-box">
                            <p class="expand-table">{{props.row.onDutyClock+'-'+props.row.offDutyClock}}</p>
                        </div>
                    </template>
                </el-table-column>
                <!-- expand -->
                <el-table-column :label="'待岗时间段'" :prop="'leaveClock'" :key="'待岗时间'"
                                 align="center"
                                 sortable="custom">
                    <template slot-scope="props">
                        <div class="expand-box">
                            <p class="expand-table" v-for=" (item,index) in props.row.leaveClock" :key="index+''">{{item.start.clockTime+'-'+(item.end.clockTime?item.end.clockTime:'')}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="'其他类别时间段'" :prop="'emergencyClock'" :key="'其他类别时间'"
                                 align="center"
                                 sortable="custom">
                                 <template slot-scope="props">
                        <div class="expand-box">
                            <p class="expand-table" v-for=" (item,index) in props.row.emergencyClock" :key="index+''">{{item.start.clockTime+'-'+(item.end.clockTime?item.end.clockTime:'')}}</p>
                        </div>
                    </template>
                </el-table-column>
                <!-- column title -->
                <el-table-column :prop="'workTime'" :label="'作业时间(小时)'" :key="'作业时间'"
                                 align="center"
                                 sortable="custom">
                        <span slot-scope="scope">
                        {{(scope.row.workTime/3600).toFixed(1)!='0.0'?(scope.row.workTime/3600).toFixed(1):'0'}}
                    </span>
                </el-table-column>

            </data-tables>
        </div>
    </div>
    </sub-page>
</template>

<script>
    import api from '@/api';
     import SubPage from '@/components/Subpage'
     import {Ticket} from '@/utils';
     import qs from 'qs'

    export default {
        data() {
            return {
                currentPage: 1,
                tableData: [],
                subData: {},
                tableProps: {
                    border: false,
                    stripe: true,
                    height: 'auto'
                },
               exportUrl: ''
            }
        },
        created() {
            this.query();
        },
        mounted() {

        },
         destroyed(){
            this.$emit('onClose');
        },
        computed: {},
        methods: {
            query() {
                api.getTimeSheetStatisticDetail(this.$route.query.attendanceId,{month:this.$route.query.month}).then(res => {
                    this.subData = res.data;
                    let data = res.data.statistics;
                    this.tableData = data;
                });
            },
            exportUser(formName) {
                if(!this.tableData.length){
                     this.$message({
                        type: 'warning',
                        message: '无统计数据，无法导出！'
                    });
                    return;
                }
                let queryData = {
                    month:this.$route.query.month,
                    jwt: Ticket.get().access_token,
                    culture: this.$i18n.locale,
                    'ui-culture': this.$i18n.locale
                }

                this.exportUrl = APIURI + `clockApi/statistic/${this.$route.query.attendanceId}/download?` + qs.stringify(queryData)

                this.$nextTick(() => {
                    $('#export-b')[0].click();
                });
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        watch: {

        },
        components: {
            SubPage,
        }
    }
</script>

<style scoped lang="scss">
.menuPage {
    height: 100%;
    .page-table{
        height: 100%;
    }
        .map-info {
            display: flex;
            margin: -5px 0 15px 10px;
            line-height: 22px;
        }
     /deep/ tr {
            font-size: 15px;
            color: #333;
        }

       .expand-table {
            font-size: 13px;
            color: #666;

        }

     /deep/.el-table__expanded-cell {
            border-bottom: none;
        }
    }

</style>


